import {SignupSummaryRateSchedules} from './signup_summary_rate_schedule_cards'
require("payment")

export class Signup extends HTMLElement {
  constructor() {
    super();
  }

  getStyles() {
    return `
      <style>
        @font-face {
          font-family: 'Glyphicons Halflings';
          src: url('/assets/glyphicons-halflings-regular.eot');
          src: url('/assets/glyphicons-halflings-regular.eot?#iefix') format('embedded-opentype'),
              url('/assets/glyphicons-halflings-regular.woff') format('woff'),
              url('/assets/glyphicons-halflings-regular.ttf') format('truetype'),
              url('/assets/glyphicons-halflings-regular.svg#glyphicons_halflingsregular') format('svg');
        }

        sign-up input, sign-up select,
        sign-up img {
          margin-bottom: 10px;
        }

        sign-up .fa-check {
          color: green;
        }

        sign-up h2 {
          margin: 30px 0 0 0;
        }

        .signup_background, .signup_thankyou,
        .signup_loading {
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .signup_main {
          width: 1178px;
          border-radius: 10px;
          box-shadow: 1px 4px 3px lightgray;
          background-color: white;
          padding: 20px;
        }

        .select-half-width-left {
          padding-left: 0 !important;
        }
      
        .select-half-width-right {
          padding-right: 0 !important;
        }

        .signup_summary {
          height: 85%;
        }

        .signup_info {
          padding-top: 5px;
        }

        .singup_amount {
          font-weight: bold;
          font-size: 36px;
        }

        .singup_per_month {
          font-weight: bold;
          font-size: 24px;
        }

        .signup_features, .signup_additional_fees {
          font-size: 16px;
          display: block;
        }

        .plan_fee_header {
          display: inline-block;
        }

        .signup_additional_fees {
          margin-top: 14px;
        }

        sign-up a {
          cursor: pointer;
        }

        .signup_card_container {
          position: relative;
        }

        sign-up .fa-lock {
          position: absolute;
          right: 20px;
          top: 10px;
        }

        #ai_signup_logo {
          width: 200px;
        }

        .signup_background {
          background-image: linear-gradient(to right, rgba(231, 240, 254, 0.8) 0 100%), url(/assets/signup_background.png);
          background-size: cover;
        }

        .pricing-card {
          border: none !important;
          box-shadow: none;
        }

        .signup_thankyou {
          flex-direction: column;
          padding: 40px;
        }

        .signup_thankyou h1 {
          font-weight: bold;
        }

        .signup_thankyou h3 {
          color: green;
        }

        .signup_loading {
          height: 735px;
        }
      </style>    
    `
  }
  
  async connectedCallback() {
    this.innerHTML =
      `
      ${this.getStyles()}
      
      <div class="signup_background">
        <div class="signup_main row">
          <div class="col-md-12">
            <img src="/assets/logo-newco-dark.png" id="ai_signup_logo">
          </div>
          <div class="col-md-12">
            <h3>Create Business Profile</h3>
            <div class="errors"></div>
          </div>
          <div class="signup_info col-md-7">
            <label>Account Name</label>
            <input class="form-control" id="signup_account_name">
            <div class="col-md-6 select-half-width-left">
              <label>User Email</label>
              <input class="form-control" id="signup_email">
            </div>
            <div class="col-md-6 select-half-width-right">
              <label>Phone Number</label>
              <input class="form-control" id="signup_phone_number">
            </div>
            <label>Website URL</label>
            <input class="form-control" id="signup_website">
            <label>Business Industry</label>
            <select id="signup_industry" is="industries-select" class="form-control"></select>
            
            <h4>Payment Information</h4>
            <label>Name on Card</label>
            <input class="form-control" id="signup_card_name">

            <label>Credit Card Number</label>
            <div class="signup_card_container">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <input class="form-control" id="signup_card_number">
            </div>

            <div class="col-md-6 select-half-width-left">
              <label>Billing Zip Code</label>
              <input class="form-control" id="signup_zipcode">
            </div>
            <div class="col-md-6 select-half-width-right">
              <label>Country</label>
              <select class="form-control" id="signup_country">
                <option value="US">United States</option>
                <option value="CA">Canada</option>
              </select>
            </div>
            <div class="col-md-6 select-half-width-left">
              <label>Expiration (MM/YY)</label>
              <input class="form-control" id="signup_expiration">
            </div>
            <div class="col-md-6 select-half-width-right">
              <label>CVC</label>
              <input class="form-control" id="signup_cvc" maxlength=4>
            </div>
          </div>

          <div class="signup_summary col-md-5">
            <h4>Summary</h4>
            <div id="signup_summary_menu"></div>

            <br>
            <input type="checkbox" id="tos_checkbox">
            <span>I accept the <a>AutoID Terms of Service</a> and have read the <a>AutoID Privacy Policy</a>.</span>
          </div>
          <div class="col-md-12">
            <button class="btn btn-primary pull-right" id="signup_create" disabled>Create Account</button>
          </div>
        </div>
      </div>
      `;

    let rate_schedule_id = this.getAttribute("rs");
    const summaryEl = this.querySelector('#signup_summary_menu')
    if (summaryEl) {
      summaryEl.appendChild(new SignupSummaryRateSchedules(rate_schedule_id))
    }
    
    this.querySelector('#tos_checkbox').onchange = (e) => {e.target.checked ? this.querySelector('#signup_create').disabled = false : this.querySelector('#signup_create').disabled = true}
    $(this.querySelector("#signup_phone_number")).mask('(999) 999-9999');
    Payment.formatCardNumber(this.querySelector('#signup_card_number'))
    // $(this.querySelector("#signup_expiration")).mask('99/99');
    Payment.formatCardExpiry(this.querySelector('#signup_expiration'))
    Payment.formatCardCVC(this.querySelector('#signup_cvc'));
    this.querySelector('#signup_create').addEventListener('click', function() {
      this.processData()
    }.bind(this))
  }


  validate() {
    this.querySelector('.errors').innerHTML = '';
    this.querySelectorAll('.error').forEach(e => {
      e.classList.remove('error');
    })
    let isValid = true;
    let error = '';
    let cc_valid = Payment.fns.validateCardNumber(this.querySelector('#signup_card_number').value);
    let cc_type = Payment.fns.cardType(this.querySelector('#signup_card_number').value);
    let date_valid = Payment.fns.validateCardExpiry(this.querySelector('#signup_expiration').value);
    let cvc_valid = Payment.fns.validateCardCVC(this.querySelector('#signup_cvc').value, cc_type);
    console.log(cc_valid)
    console.log(cc_type)
    console.log(date_valid)
    console.log(cvc_valid)
    let cvc = this.querySelector('#signup_cvc').value.replace(/\D/g, '');
    let validRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i;

    this.querySelectorAll('input:not(#signup_website), select').forEach(e => {
      if(!e.value || e.value == 'null') {
        e.classList.add('error');
        error = `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Required field missing.
                  </div>`;
        isValid = false;
      }
    })

    if(this.querySelector('#signup_email').value.trim() != "" && !this.querySelector('#signup_email').value.match(validRegex)) {
      this.querySelector('#signup_email').classList.add('error');
      error += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please enter a valid email address.
                  </div>`;
      isValid = false;
    }

    if(!cc_valid) {
      this.querySelector('#signup_card_number').classList.add('error');
      error += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Invalid credit card number.
                  </div>`;
      isValid = false;
    }

    if(!date_valid) {
      this.querySelector('#signup_expiration').classList.add('error');
      error += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Invalid expiration date.
                  </div>`;
      isValid = false;
    }

    if(!cvc_valid) {
      this.querySelector('#signup_cvc').classList.add('error');
      error += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Invalid CVC.
                  </div>`;
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = error;

    return isValid
  }

  // if form data is validated, send request to generate the auto group and stripe data
  async processData() {
    if (this.validate()){
      const signup_account_name = this.querySelector('#signup_account_name').value.trim();
      const signup_email = this.querySelector('#signup_email').value.trim();
      const signup_phone_number = this.querySelector('#signup_phone_number').value.trim();
      const signup_website = this.querySelector('#signup_website').value.trim();
      const signup_industry = this.querySelector('#signup_industry').value.trim();

      const rate_schedule_menu = document.querySelector('signup-summary-rate-schedule-cards')
      if (! rate_schedule_menu){
        console.log('Unable to find selected rate schedule')
        return
      }
      const selected_rate_schedule_id = rate_schedule_menu.getSelectedRateScheduleId()

      const name_on_card = this.querySelector('#signup_card_name').value.trim()
      const billing_zip_code = this.querySelector('#signup_zipcode').value.trim()
      const country = this.querySelector('#signup_country').value.toLowerCase()
      const card_number = this.querySelector('#signup_card_number').value
      const card_expiration = this.querySelector('#signup_expiration').value.replace(/ /g,'');
      const card_cvc = this.querySelector('#signup_cvc').value

      
      let data = {
        name: signup_account_name,
        email: signup_email,
        phone: signup_phone_number,
        domain_name: signup_website,
        industry_id: parseInt(signup_industry),
        rate_schedule_id: selected_rate_schedule_id,
        name_on_card: name_on_card,
        zip_code: billing_zip_code,
        country: country,
        card_number: card_number,
        card_expiration: card_expiration,
        card_cvc: card_cvc
      }

      this.changeBusyState(true)
      // this.loading();
      console.log(data)

      let url = `/signup/create_account`
      let result = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).catch(error => {
        console.error('There was an error!', error);
        this.displayError(error)
        this.changeBusyState()
        return
      }); 

      let response = await result.json();
      console.log('create account result: ', response)

      this.changeBusyState()

      if (response.error) {
        this.displayError(response.error)
      }
      else {
        this.thankyouSplash();
      }
    }
  }

  enableSend(){
    const send_el = this.querySelector('#signup_create')
    if (send_el){
      send_el.removeAttribute('disabled')
      send_el.innerText = 'Create Account'
    }
  }

  disableSend(){
    const send_el = this.querySelector('#signup_create')
    if (send_el){
      send_el.setAttribute('disabled', true)
      send_el.innerText = 'Creating Account...'
    }
  }
  
  // busy = true, ui is updated to reflect busy status
  // busy = false, ui is reset to ready state
  changeBusyState(busy=false) {
    if (busy) {
      this.disableSend()
    }
    else {
      this.enableSend()
    }
  }
  
  displayError(error_msg) {
    console.log('creation error: ', error_msg)
    let error = ``
    if (typeof error_msg === 'object' && error_msg.constructor === Array) {
      console.log(error_msg.constructor === Array)
      error_msg.forEach(msg => {
        error += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> ${msg}
                  </div>`;
      })

      this.querySelector('.errors').innerHTML = error;
    } else if (typeof error_msg === 'object') {
      error_msg = error_msg.message
      this.querySelector('.errors').innerHTML = error_msg;
    }
    
  }
  
  updatePlan(num) {
    this.querySelector('#signup_plan_fee').innerHTML = num;
  }

  // loading() {
  //   this.querySelector('.signup_main').innerHTML =
  //     `
  //     <div class="signup_loading">
  //       <img src="/assets/loading.gif">
  //     </div>
  //     `;
  // }

  thankyouSplash() {
    this.querySelector('.signup_main').innerHTML =
      `
      <div class="signup_thankyou">
        <h1>Thank You</h1>
        <h3>Please check your email to activate your account.</h3>
      </div>
      `;
  }
}

customElements.define('sign-up', Signup)
